import React from "react";
import Footer from "../components/Footer";
import Navbaraboutus from "../components/Navbaraboutus";
import Sec101 from "../components/Sec101";
import "../styles/Aboutus.css";
import { CircularProgressbar} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Navbar1 from "../components/Navbar1";

function Aboutus() {

  const percentage = 90;

  const percentage2 = 90;

  const percentage3 = 60;

  const percentage4 = 95;


  return (
    <>
    <Navbar1 />


    <div className="container my-5">
  <h2 className="text-center mb-4">Founding Team & Key Professionals</h2>

  {/* Row 1: Three people */}
  <div className="row mb-4">
    {/* Card 1 */}
    <div className="col-md mb-3">
      <div className="border rounded shadow p-3 h-100">
        <div className="bg-teal text-white text-center py-2 rounded mb-3">
          <div className="text-sm font-semibold">Partner</div>
          <div className="text-lg font-bold">Yugandhar Kummathi</div>
        </div>
        <p>
          My role will be investor relations—essentially seeking capital contributions from investors and managing those relationships as the asset matures. Also to ensure capital and return guaranteed.
        </p>
        <p className="text-sm mt-2">
          Background as a Design Engineer with L&T ECC & a consultant for L&T Ramboll. Expertise in IT for Banking and Credit Cards, holding a BTech in Civil Eng. from JNTU and an MTech from NIIT.
        </p>
      </div>
    </div>

    {/* Card 2 */}
    {/* <div className="col-md-4 mb-3">
      <div className="border rounded shadow p-3 h-100">
        <div className="bg-teal text-white text-center py-2 rounded mb-3">
          <div className="text-sm font-semibold">Partner</div>
          <div className="text-lg font-bold">Chennakesava Reddy Kummathi</div>
        </div>
        <p>
          Focusing on investor relationships, customer relationship management, and new property acquisitions. Brings a wealth of experience in identifying and securing strategic real estate opportunities.
        </p>
      </div>
    </div> */}

    {/* Card 3 */}
    <div className="col-md mb-3">
      <div className="border rounded shadow p-3 h-100">
        <div className="bg-teal text-white text-center py-2 rounded mb-3">
          <div className="text-sm font-semibold">Partner</div>
          <div className="text-lg font-bold">Kamalika Paramahansa Kummathi</div>
        </div>
        <p>
          Finance, Economics, Digital marketing, Venture capital, Investments specialist and Risk Analyst.
        </p>
      </div>
    </div>
  </div>

  {/* Row 2: KPN Properties Investment */}
  <div className="row">
    <div className="col-md-12">
      <div className="bg-teal text-white p-4 rounded shadow">
        <h5 className="mb-3">KPN Properties Investment</h5>
        <p>
          KPN manages investment activities and real estate portfolio managed by <strong>KPN Properties</strong>, a real estate development and investment company. The allocation of capital into various real estate assets, such as residential, commercial, industrial, or mixed-use properties, with the goal of generating returns through <strong>rental income, property appreciation, or development projects</strong>.
        </p>
        <p className="mt-3">
          <strong>KR Real Estate Developers & KR Homes</strong><br />
          The primary entity also supporting KPN Properties Investment, fund wing of KR Homes.
        </p>
      </div>
    </div>
  </div>
</div>
    
    
{/* <div className="container-fluid">
        <div className="col-lg-12 py-5 px-4">
          <div className="row">
          <div class="d-flex flex-column justify-content-Center align-items-center col-lg col-md col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
          <div style={{ width: 200, height: 200 }}>
    <CircularProgressbar  value={percentage} text={`${percentage}%`} />;
</div>
              <div className="sect2headingaboutus">Discover and process</div>
              <div className="contaboutus">
                Lorem ipsum dolor sit amet, facilis admodum officiis enim
              </div>
            </div> 

            <div class="d-flex flex-column justify-content-Center align-items-center col-lg col-md col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
          <div style={{ width: 200, height: 200 }}>
    <CircularProgressbar value={percentage2} text={`${percentage2}%`} />;
</div>
              <div className="sect2headingaboutus">Discover and process</div>
              <div className="contaboutus">
                Lorem ipsum dolor sit amet, facilis admodum officiis enim
              </div>
            </div> 

            <div class="d-flex flex-column justify-content-Center align-items-center col-lg col-md col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
          <div style={{ width: 200, height: 200 }}>
    <CircularProgressbar value={percentage3} text={`${percentage3}%`} />;
</div>
              <div className="sect2headingaboutus">Discover and process</div>
              <div className="contaboutus">
                Lorem ipsum dolor sit amet, facilis admodum officiis enim
              </div>
            </div> 

            <div class="d-flex flex-column justify-content-Center align-items-center col-lg col-md col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
          <div style={{ width: 200, height: 200 }}>
    <CircularProgressbar value={percentage4} text={`${percentage4}%`} />;
</div>
              <div className="sect2headingaboutus">Discover and process</div>
              <div className="contaboutus">
                Lorem ipsum dolor sit amet, facilis admodum officiis enim
              </div>
            </div> 
        </div>
        </div>
        </div> */}


{/* <div style={{ width: 200, height: 200 }}>
    <CircularProgressbar value={percentage2} text={`${percentage2}%`} />;
</div>

<div style={{ width: 200, height: 200 }}>
    <CircularProgressbar value={percentage3} text={`${percentage3}%`} />;
</div>

<div style={{ width: 200, height: 200 }}>
    <CircularProgressbar value={percentage4} text={`${percentage4}%`} />;
</div>
</div> */}










      {/* Section3 of Aboutus */}

      <div className="container sect3bcolor">
        <div className=" col-lg-12 pb-5">
          <div className="row">
            <div className="d-flex flex-column justify-content-center align-items-lg-start align-items-center col-lg-6">
              <div className="sect3aboutus text-lg-start text-center">
                Our development team members
              </div>

              <div className="sect3aboutus2 text-lg-start text-center">
                Lorem ipsum dolor sit amet, conse quat reprimique eu mel. Ne sed
                muner di ceret. Explicari moderat, cu aperiri qualisque sit,
                eros putant definitiones no erasmus sed.
              </div>
            </div>

            <div className="sect3aboutusimg col-lg-6 pt-lg-0 pt-4">
              <img
                src={require("../images/sect3img.png")}
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section4 of Aboutus */}

      {/* <div className="container-fluid mt-4 sec4bgcolabus">
        <div className="col-lg-12 pt-5 px-4 pb-lg-5">
          <div className="row">
            <div className=" d-flex flex-column align-items-center col-lg col-12 numtxt ms-lg-4 px-md-4 pb-lg-0 pb-2">
            <div>412</div>
            <h3>DUPLEX</h3>
            </div>

            <div className=" d-flex flex-column align-items-center col-lg col-12 numtxt ms-lg-4 px-md-4 pb-lg-0 pb-2">
            <div>519</div>
            <h3>VILLAS</h3>
            </div>

            <div className=" d-flex flex-column align-items-center col-lg col-12 numtxt ms-lg-4 px-md-4 pb-lg-0 pb-2">
            <div>170</div>
            <h3>APARTMENTS</h3>
            </div>

            <div className=" d-flex flex-column align-items-center col-lg col-12 numtxt ms-lg-4 px-md-4 pb-lg-0 pb-2">
            <div>262</div>
            <h3>ROOMS</h3>
            </div>
          </div>
        </div>
      </div> */}

      {/* Section5 of Aboutus */}

      {/* <div className="thumbnail">
        <div className="container">
          <div className="col-lg-9 mx-auto padthumbnail">
            <div className="playbutton mx-auto d-flex justify-content-center align-items-center">
              <img src={require("../images/pbutton.png")} alt="" className="" />
            </div>
          </div>
        </div>
      </div> */}

      {/* Section6 of Aboutus */}

      {/* <div className="container-fluid">
        <div className="col-lg-12 py-5 px-4">
          <div className="row">
            <div class="d-flex flex-column justify-content-Center  col-lg col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
              <div className="sect6aboutus">01</div>
              <div className="sect6headingaboutus">PLANNING STAGE</div>
              <div className="cont6aboutus">
                Lorem ipsum dolor sit amet, facilis admodum officiis enim
              </div>
            </div>

            <div class="d-flex flex-column justify-content-Center col-lg col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
              <div className="sect6aboutus">02</div>
              <div className="sect6headingaboutus">DEVELOPMENT</div>
              <div className="cont6aboutus">
                Lorem ipsum dolor sit amet, facilis admodum officiis enim
              </div>
            </div>

            <div class="d-flex flex-column justify-content-Center col-lg col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
              <div className="sect6aboutus">03</div>
              <div className="sect6headingaboutus">EXECUTION PHASE</div>
              <div className="cont6aboutus">
                Lorem ipsum dolor sit amet, facilis admodum officiis enim
              </div>
            </div>

            <div class="d-flex flex-column justify-content-Center col-lg col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
              <div className="sect6aboutus">04</div>
              <div className="sect6headingaboutus">NEW WAY OF LIVING</div>
              <div className="cont6aboutus">
                Lorem ipsum dolor sit amet, facilis admodum officiis enim
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Section7 of Aboutus */}


      {/* <div className="container-fluid sect101bcolor">
        <div className=" col-lg-12 pt-3 pb-5">
          <div className="row align-items-center justify-content-center">
            <div className="d-flex flex-column justify-content-center pt-5 pb-3 align-items-lg-start align-items-center col-lg-6">
              <div className="s7h text-lg-start text-center">
                SCHEDULE A MEETING
              </div>

              <div className="s7sh text-lg-start text-center">
                Lorem ipsum dolor sit amet, conse quat reprimique eu mel. Ne sed
                muner di ceret. Explicari moderat, cu aperiri qualisque sit,
                eros putant definitiones no erasmus sed.
              </div>
            </div>

            <div className="dcontents col-lg-6 pt-lg-0 pt-4">
              <div className="btnborderaboutus btntxtaboutus pt-2 mt-4 mb-sm-3 mb-lg-0 text-center">
                Request
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Section8 of Aboutus */}


      {/* <div className="container-fluid bgsect8color">
        <div className="col-lg-12 py-5 px-4">
          <div className="sect8headingmain">MEET THE TEAM</div>
          <div className="sect8subheadingmain pb-3">
          Meet Our Expert Team
Members          </div>
          <div className="row">
            <div class="d-flex flex-column justify-content-Center align-items-center col-md col-12 my-3 px-sm-4 pe-lg-1 mx-lg-1 aboutsect2img">
              <img
                src={require("../images/testimonialPHolder.png")}
                alt=""
                className="img-fluid"
              />
              <div className="sect8headingaboutus pt-4">IVET HOUZE</div>
              <div className="sect8subheading pt-0">ARCHITECT ASSISTANT</div>
            </div>

            <div class="d-flex flex-column justify-content-Center align-items-center col-md col-12 my-3 px-sm-4 px-lg-1 mx-lg-1 aboutsect2img">
              <img
                src={require("../images/testimonialPHolder.png")}
                alt=""
                className="img-fluid"
              />
              <div className="sect8headingaboutus pt-4">IVET HOUZE</div>
              <div className="sect8subheading pt-0">ARCHITECT ASSISTANT</div>
            </div>

            <div class="d-flex flex-column justify-content-Center align-items-center col-md col-12 my-3 px-sm-4 ps-lg-1 mx-lg-1 aboutsect2img">
              <img
                src={require("../images/testimonialPHolder.png")}
                alt=""
                className="img-fluid"
              />
              <div className="sect8headingaboutus pt-4">IVET HOUZE</div>
              <div className="sect8subheading pt-0">ARCHITECT ASSISTANT</div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Section9 of Aboutus */}

      <Footer />
    </>
  );
}

export default Aboutus;
